<template>
  <div class="modal open" ref="popup">
    <div class="modal-bg modal-exit" @click="close" ref="closeBtn"></div>
    <div class="modal-container">
      <img
        class="animate"
        v-lazy="require('@/assets/img/popup.jpg')" />
      <button class="modal-close modal-exit" @click="close">X</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Popup',
  components: {
  },
  methods: {
    close: function () {
      const modal = this.$refs.popup
      modal.classList.remove('open')
    }
  }
}
</script>

<style>
  .modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    padding: 3vh 0;
  }
  .modal.open {
    visibility: visible;
    opacity: 1;
    transition-delay: 0s;
  }
  .modal-bg {
    position: absolute;
    background: rgba(30, 94, 79, 0.7);
    width: 100%;
    height: 100%;
  }
  .modal-container {
    border-radius: 10px;
    background: #fff;
    position: relative;
    padding: 2rem;
    max-width: 800px;
  }
  .modal-container img {
    width: 100%;
  }
  .modal-close {
    position: absolute;
    right: 15px;
    top: 15px;
    outline: none;
    appearance: none;
    color: #2e6553;
    background-color: rgba(0, 0, 0, 0);
    border: 0px;
    font-weight: bold;
    cursor: pointer;
    background-color: #fff;
    padding: 2rem;
    border-radius: 60px;
    font-size: 3rem;
    box-shadow: 0 0 5px #0000003b;
  }

  @media (max-width:600px) {
    .modal-container {
      max-width: 85vw;
      padding: 1rem;
    }
  }
</style>
